import { cn } from '@commenda/utils';
import { SecureInformationRequestLayoutFooter } from './SecureInformationRequestFooter';
import { SecureInformationRequestLayoutHeader } from './SecureInformationRequestHeader';
import { ISecureInformationRequestHeaderProps } from './types';

export const SecureInformationRequestLayout = ({
  children,
  className,
  onSaveAndExitProps,
  submitProps,
  onCancel,
  onClose,
  headerProps,
}: {
  children: React.ReactNode;
  className?: string;
  onSaveAndExitProps?: {
    isEnabled: boolean;
    onClick: () => void;
  };
  submitProps: {
    isEnabled: boolean;
    onClick: () => void;
  };
  onCancel: () => void;
  onClose: () => void;
  headerProps: ISecureInformationRequestHeaderProps;
}) => {
  return (
    <main className="flex flex-col h-screen w-full">
      <SecureInformationRequestLayoutHeader
        onClose={onClose}
        headerProps={headerProps}
      />
      <div
        className={cn(
          'flex-1 overflow-y-auto bg-bg-primary py-5xl px-6xl',
          className
        )}
      >
        {children}
      </div>
      <SecureInformationRequestLayoutFooter
        onSaveAndExitProps={onSaveAndExitProps}
        submitProps={submitProps}
        onCancel={onCancel}
      />
    </main>
  );
};
